import { render } from "./EventTableRow.vue?vue&type=template&id=3a1e8476&scoped=true"
import script from "./EventTableRow.vue?vue&type=script&lang=js"
export * from "./EventTableRow.vue?vue&type=script&lang=js"

import "./EventTableRow.vue?vue&type=style&index=0&id=3a1e8476&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1e8476"]])

export default __exports__